import React from "react";
// import AddNewDomain from "./AddNewDomain";
import OnePageSEOChecker from "./OnePageSEOChecker";

const SEOManagement = () => {
  return (
    <>
      {/* <AddNewDomain/> */}
      <OnePageSEOChecker/>
    </>
  );
};

export default SEOManagement;
